import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Button, Drawer, Menu } from 'antd'
import { HomeOutlined, MenuOutlined } from '@ant-design/icons'
import logo from '../../assets/logo.svg'
import { paths, sectionRoot } from '../../routes'
import { sections } from '../../sections'
import SectionIcon from '../ui/SectionIcon'
import RegionSelect from '../RegionSelect'

const TopBar: React.FC = () => {
    const { pathname } = useLocation()
    const [drawerOpen, setDrawerOpen] = useState<boolean>(false)

    useEffect(() => {
        setDrawerOpen(false)
    }, [pathname])

    // Keys are section roots so the active tab follows nested routes
    const items = [
        { key: paths.home, icon: <HomeOutlined />, label: <Link to={paths.home}>Home</Link> },
        ...sections.map((section) => ({
            key: section.root,
            icon: <SectionIcon section={section} />,
            label: <Link to={section.root}>{section.label}</Link>,
        })),
    ]
    const selectedKeys = [sectionRoot(pathname)]

    return (
        <header className="topbar">
            <Link to={paths.home} className="topbar-brand" aria-label="Wallex Simulator home">
                <img src={logo} alt="Wallex" />
                <span className="topbar-product">Simulator</span>
            </Link>

            <Menu className="topbar-menu" mode="horizontal" items={items} selectedKeys={selectedKeys} />

            <div className="topbar-actions">
                <RegionSelect />
            </div>

            <Button className="topbar-burger" type="text" icon={<MenuOutlined />} aria-label="Open navigation" onClick={() => setDrawerOpen(true)} />
            <Drawer title="Wallex Simulator" placement="right" width={280} open={drawerOpen} onClose={() => setDrawerOpen(false)} bodyStyle={{ padding: 0 }}>
                <Menu mode="inline" items={items} selectedKeys={selectedKeys} style={{ borderRight: 0 }} />
                <div className="drawer-section">
                    <RegionSelect />
                </div>
            </Drawer>
        </header>
    )
}

export default TopBar
